__turbopack_context__.v({
  "center": "ccvktW_center",
  "end": "ccvktW_end",
  "fieldset": "ccvktW_fieldset",
  "input": "ccvktW_input",
  "label": "ccvktW_label",
  "small": "ccvktW_small",
  "tab": "ccvktW_tab",
  "tabText": "ccvktW_tabText",
  "vertical": "ccvktW_vertical",
  "wrapper": "ccvktW_wrapper",
});
